export enum TelematicsEventType {
  FLEET = 'fleet',
  TELEMETRY = 'telemetry',
  ROUTE = 'route',
  TACHOGRAPH = 'tachograph',
  ORDER_STATUS = 'order-status',
  ORDER_POINT_STATUS = 'order-point-status',
}
